import { makeObservable, observable, action, reaction,when } from 'mobx';
import axios from 'axios';

class dataStore {
  route="";
  sort_mode=false;
  data={
    inited: false,
    fetching: false,
    data:{},
  };

  par=null;
  constructor(par) {
    this.par=par;

    makeObservable(this,{
      route:observable,
      data:observable,
      sort_mode:observable,
    });

    when(
      ()=>{ return this.par.configStore.config.data.data_route; },
      ()=>{
        this.refreshData(true);
      }
    );
    reaction(()=>{
      return this.par.memoryStore.memory_str;
    },()=>{
      this.refreshData(true);
    });
    reaction(()=>{
      return this.par.configStore.config.data.data_route
    },(dataRoute)=>{
      this.route=dataRoute;
      this.refreshData(true);
    })
  }
  move(ids,position,to) {
    const flt=this.par.searchStore.getFilter();
    let section=null;
    if(flt.section && flt.section[0]) {
      section=flt.section[0];
    }
    const url=this.par.configStore.config.data.sort_route;
    if(url) {
      const postData={ids, position, to};
      if(section) {
        postData.section=section;
      }
      axios.post(url, postData).then(() => {
        this.refreshData();
      });
    }

  }
  refreshData(checkLast=false) {

    if(this._ta) {
      clearTimeout(this._ta);
    }
    this._ta=setTimeout(()=>{

      const req=this.par.memoryStore.getRequest();

      const curJson=JSON.stringify(req);
      if(curJson !== this._lastLoad) {
        console.log("wasJson",this._lastLoad);
        console.log("curJson",curJson);
        this._lastLoad = curJson;
        this.data.fetching=true;
        axios.post(req.url, req.data).then((data) => {
          this.data.data = data.data.answer;
          this.data.fetching = false;
          this.data.inited = true;
        });
      }
    },10);
  }
}


export default dataStore;
